<div class="alert-stack row">
  <gpei-alert
    #alert
    *ngFor="let alert of alerts$ | async"
    class="col-12 col-xs-12"
    [type]="alert.level"
    [closeable]="alert.closeable == null ? true : alert.closeable"
    (dismiss)="onDismiss(alert)">
    <div [innerHtml]="alert.text"></div>
    <ng-container *ngIf="alert.actions">
      <a *ngFor="let action of alert.actions | keyvalue" class="btn btn-primary btn-sm" [routerLink]="action.value">{{ action.key }}</a>
    </ng-container>
  </gpei-alert>
</div>
